import React, { Component } from "react";
import sentGAEvent from "@/ga";

import CropPicRender from "./chidlren/CropPicRender";

class CropPicFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crop: {
        aspect: 1,
        x: 0,
        y: 0,
        width: 150,
        height: 150,
      },
      visible: false,
      imageReady: false,
    };
  }

  handleChangeCrop = crop => {
    if (crop.width < 10 || crop.height < 10) {
      return false;
    }
    this.setState({ crop });
  };

  handleSubmit = () => {
    let category, action;
    switch (this.props.work) {
      case "addLipShape":
        category = "FaceAnimator";
        action = "FaceCrop";
        break;
      case "dynamicPhoto":
        category = "AnimateOld";
        action = "OldCrop";
        break;
      default:
        break;
    }
    sentGAEvent({
      category,
      action,
    });
    this.cropImage();
    setTimeout(() => {
      this.props.handleCropSubmit();
    }, 500);
  };

  cropImage = () => {
    const { crop } = this.state;
    const imageCont = document.querySelector("#crop");
    console.log(crop, imageCont.width, imageCont.height, imageCont.clientHeight, imageCont.clientWidth);
    const newCrop = {
      visible: false,
      x: parseInt(((crop.x / imageCont.clientWidth) * 100).toFixed(2)),
      y: parseInt(((crop.y / imageCont.clientHeight) * 100).toFixed(2)),
      width: parseInt(((crop.width / imageCont.clientWidth) * 100).toFixed(2)),
      height: parseInt(((crop.height / imageCont.clientHeight) * 100).toFixed(2)),
      aspect: crop.aspect,
    };
    console.log(newCrop);
    this.props.onCropChange(newCrop);
  };

  onImageLoaded = () => {
    const imageCont = document.querySelector(".crop-cont");
    const image = document.querySelector("#crop-pic");
    image.style.width = "100%";
    image.style.height = "auto";
    image.onload = () => {
      if (image.clientHeight >= imageCont.clientHeight) {
        image.style.width = "auto";
        image.style.height = imageCont.clientHeight + "px";
        image.parentNode.style.height = imageCont.clientHeight + "px";
      } else {
        image.style.width = "100%";
        image.style.maxHeight = "300px";
        image.style.height = "auto";
        image.parentNode.style.height = image.clientHeight + "px";
        this.setState({
          crop: {
            aspect: 1,
            x: 0,
            y: 0,
            width: imageCont.childNodes[0].clientHeight >= 300?  100 :imageCont.childNodes[0].clientHeight,
            height: imageCont.childNodes[0].clientHeight >= 300? 100 :imageCont.childNodes[0].clientHeight,
          },
          imageReady: true,
        });
        return
      }
      this.setState({
        crop: {
          aspect: 1,
          x: 0,
          y: 0,
          width: 100,
          height: 100,
        },
        imageReady: true,
      });
    };
  };

  componentDidUpdate(prevProps) {
    if (this.props.crop !== prevProps.crop && this.props.crop && this.props.crop.visible && !this.state.imageReady) {
      this.onImageLoaded();
    }
  }

  render() {
    return (
      <CropPicRender
        visible={this.props.crop ? this.props.crop.visible : false}
        crop={this.state.crop}
        currFile={this.props.currFile}
        changeCrop={this.handleChangeCrop}
        handleSubmit={this.handleSubmit}
        onCancel={this.props.onCropModalClose}
      />
    );
  }
}

export default CropPicFunction;
